module.exports = __webpack_public_path__ + "img/nlgc1.a3de3c44.png";